module.exports = __webpack_public_path__ + "static/media/Paul_Ryan.7ba579f4.jpg";